import styled from 'styled-components';
import { Paragraph } from '../Paragraph/Paragraph';
export var StyledComboboxEmptyState = /*#__PURE__*/styled(Paragraph).withConfig({
  displayName: "StyledComboboxEmptyState",
  componentId: "c11n-8-111-1__sc-lsfax2-0"
})([""]);